const msizeButtons = document.querySelectorAll('.msize');
  msizeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
          msizeButtons.forEach(function (btn) {
              btn.classList.remove('active');
          });
          button.classList.add('active');
          const msizeNumber = button.classList[1].substring(5);
          const msizeDetailsElement = document.querySelector('.msize_details' + msizeNumber);
          document.querySelectorAll('.msize_details').forEach(function (details) {
              details.classList.remove('show');
          });
          msizeDetailsElement.classList.add('show');
      });
  });

document.addEventListener("DOMContentLoaded", function () {
    for (let i = 1; i <= 3; i++) {
        let titleElements = document.querySelectorAll(`.mcollection-title-${i}`);
        titleElements.forEach(function(titleElement) {
            titleElement.addEventListener("click", function () {
                // Remove mcollection-active class from all title elements
                let allTitleElements = document.querySelectorAll('.mcollection-title');
                allTitleElements.forEach(function (element) {
                    element.classList.remove('mcollection-active');
                });

                // Add mcollection-active class to the clicked title element
                titleElement.classList.add('mcollection-active');

                // Remove mcollection-active-slider class from all sliders
                let sliders = document.querySelectorAll('.mcollection-slider');
                sliders.forEach(function (slider) {
                    slider.classList.remove('mcollection-active-slider');
                });

                // Add mcollection-active-slider class to the specific slider
                let specificSlider = document.querySelector(`.mcollection-slider-${i}`);
                if (specificSlider) {
                    specificSlider.classList.add('mcollection-active-slider');
                }
            });
        });
    }
});

